import React from "react";

// Centralised LIFTILE logo component.
// variant: "mark" = wordmark only (no slogan) — header/compact
//          "full" = wordmark + "Rise With Confidence" — footer/hero/loading
// theme:   "light" = light-coloured letters, for use on DARK backgrounds (default)
//          "dark"  = original dark-gray letters, for use on LIGHT (cream/white) backgrounds

const ASSETS = {
  mark: { light: "/liftile-logo-mark-light.png", dark: "/liftile-logo-mark.png" },
  full: { light: "/liftile-logo-full-light.png", dark: "/liftile-logo-full.png" },
};

export default function Logo({
  variant = "mark",
  theme = "light",
  className = "",
  imgClassName = "",
  height,
  alt = "LIFTILE — Rise With Confidence",
  ...rest
}) {
  const src = ASSETS[variant]?.[theme] || ASSETS.mark.light;
  return (
    <img
      src={src}
      alt={alt}
      draggable={false}
      style={height ? { height, width: "auto" } : undefined}
      className={`block select-none object-contain ${imgClassName} ${className}`}
      {...rest}
    />
  );
}
